import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-data-card',
  templateUrl: './no-data-card.component.html',
  styleUrls: ['./no-data-card.component.scss']
})
export class NoDataCardComponent {
  @Input() text: string = 'No data available.';
}
